import Image from "next/image";
import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import mission from "../../assets/landing/mission.png";
import vision from "../../assets/landing/vision.png";
import { NextSeo } from "next-seo";
import InArticleAds from "../../Components/GoogleAdsense/InArticleAds";
import Engage from "../../Components/Landing/Engage/Engage";

const AboutUs = ({ adsId }) => {
  let slot = 8630513497;

  return (
    <Container>
      <NextSeo
        title="Research Rider | About"
        description="Be connected with the worldwide research hub."
        canonical="https://www.researchrider.com/our/about"
        openGraph={{
          url: "https://www.researchrider.com/our/about",
          title: "Research Rider | About",
          description: "Be connected with the worldwide research hub.",
          siteName: "Research Rider",
        }}
      />

      <Row className="justify-content-center mt-3">
        <div className="d-flex justify-content-between border py-2">
          <InArticleAds slot={slot} adsId={adsId} />
        </div>
        <div>
          <Engage />
        </div>

        <Row
          xs={1}
          md={2}
          className="g-4 p-4 justify-content-center align-items-center"
        >
          <Col>
            <div className="text-center">
              <Image
                src={mission}
                width={280}
                height={280}
                variant="top"
                alt="Research Rider mission"
                title="Research Rider mission"
              />
            </div>
            <h3 className="fs-3 py-2 fw-bold">
              The <span className="text-info">Missions</span> of Research Rider
            </h3>
            <ul>
              <li>
                Large number of research participation by the mass people along
                with raising their research interests
              </li>
              <li>
                Large number of ICT participation by the mass people along with
                raising their ICT interests
              </li>
              <li>Countywide easy accessible knowledge hunting source</li>
              <li>Reliable and productive ICT platform</li>
              <li>Reliable and well paid earning sources</li>
              <li>The production of creative ideas</li>
              <li>Easier and secured communication hub</li>
              <li>Easy and reliable ways of product marketing</li>

              <li>Efficient and effective research support</li>
              <li>Efficient and effective ICT support</li>
              <li>Reliable and well paid earning sources</li>
              <li>Maximum implementation of productive ideas</li>
            </ul>
          </Col>
          <Col>
            <div className="text-center">
              <Image
                src={vision}
                width={280}
                height={280}
                variant="top"
                alt="Research Rider vision"
                title="Research Rider vision"
              />
            </div>

            <Card.Body>
              <Card.Title className="fs-3 py-2 fw-bold">
                The <span className="text-danger">Vision</span> of Research
                Rider
              </Card.Title>
              <Card.Text>
                Research Rider will help to create a research-and-ICT lover
                society, which will certainly bring financial and non- financial
                development to society.
              </Card.Text>
            </Card.Body>
          </Col>
        </Row>
      </Row>
    </Container>
  );
};

export default AboutUs;
